import React from 'react';
import { herobg, tcbg } from '../Assets';

const PrivacyPolicy = () => {
  return (
    <div className="w-full">
      {/* Privacy Policy Section */}
      <section
        className="w-full bg-cover bg-center text-white pt-48 pb-20 px-4 sm:px-6 lg:px-12"
        style={{ backgroundImage: `url(${herobg})` }}
      >
        <div className="max-w-4xl mx-auto space-y-6">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold">Privacy Policy</h2>
          <hr className="border-t-2 border-white opacity-40 w-20" />
          <p className="text-sm sm:text-base font-light opacity-80">
            Effective Date: 25th April 2025
          </p>

          <div className="space-y-4 text-sm sm:text-base leading-relaxed">
            <p><strong>1. Introduction</strong><br />
              Welcome to PopYourBubbles. We are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you interact with our website, services, or NFTs on the Monad blockchain. By accessing our platform, you consent to the practices described herein.
            </p>

            <p><strong>2. Information We Collect</strong><br />
              ● Wallet Address: To facilitate transactions, verify ownership, and distribute airdrops.<br />
              ● Blockchain Data: Publicly available on-chain data related to your NFT transactions and holdings.<br />
              ● Contact Information: If you voluntarily provide it (e.g., for newsletters, customer support, or whitelist registration).<br />
              ● Technical Data: Including IP address, browser type, device information, and cookies for analytics and security purposes.
            </p>

            <p><strong>3. Use of Information</strong><br />
              ● Enable NFT purchases, transfers, and airdrops.<br />
              ● Improve website functionality and user experience.<br />
              ● Communicate updates, promotions, or security alerts (if you opt-in).<br />
              ● Comply with legal obligations and prevent fraudulent activities.
            </p>

            <p><strong>4. Data Sharing and Disclosure</strong><br />
              We do not sell your personal data. However, we may share information with:<br />
              ● Service Providers: Under strict confidentiality agreements.<br />
              ● Legal Authorities: If required by law.<br />
              ● Blockchain Networks: Transactions are public and immutable on Monad.
            </p>

            <p><strong>5. Data Security</strong><br />
              ● No Control Over Blockchain: Transactions cannot be altered or deleted.<br />
              ● Wallet Responsibility: You are responsible for your private keys.
            </p>

            <p><strong>6. Your Rights</strong><br />
              ● Access, correct, or delete your data.<br />
              ● Opt out of marketing.<br />
              ● Withdraw consent where applicable.
            </p>

            <p><strong>7. Policy Updates</strong><br />
              We reserve the right to modify this policy. Changes will be announced via our website or official channels.
            </p>
          </div>
        </div>
      </section>

      {/* Terms and Conditions Section */}
      <section
        className="w-full bg-cover bg-center text-[#171717] py-20 px-4 sm:px-6 lg:px-12"
        style={{ backgroundImage: `url(${tcbg})` }}
      >        <div className="max-w-4xl mx-auto space-y-6">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold">Terms and Conditions</h2>
          <hr className="border-t-2 border-[#171717] opacity-40 w-20" />
          <p className="text-sm sm:text-base font-light text-gray-600">
            Effective Date: 25th April 2025
          </p>

          <div className="space-y-4 text-sm sm:text-base leading-relaxed">
            <p><strong>1. Acceptance of Terms</strong><br />
              By accessing or using PopYourBubbles' website, services, or NFTs, you agree to these Terms.
            </p>

            <p><strong>2. Eligibility</strong><br />
              You must:<br />
              ● Be at least 18 years old.<br />
              ● Comply with NFT/crypto laws in your jurisdiction.
            </p>

            <p><strong>3. NFT Ownership & Rights</strong><br />
              ● NFT purchase = asset ownership, not IP rights (unless specified).<br />
              ● You're responsible for wallet/private key security.
            </p>

            <p><strong>4. Prohibited Conduct</strong><br />
              You may not:<br />
              ● Use NFTs illegally.<br />
              ● Resell on unauthorized platforms.<br />
              ● Infringe IP rights.
            </p>

            <p><strong>5. Disclaimers</strong><br />
              ● NFTs are “as is” — no guarantees.<br />
              ● We're not liable for blockchain issues or market risks.
            </p>

            <p><strong>6. Changes to Terms</strong><br />
              Terms may change. Continued use = acceptance.
            </p>

            <p><strong>7. Contact Us</strong><br />
              Email: [Insert Support Email]<br />
              Discord: [Insert Invite Link]
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;